module.exports = __webpack_public_path__ + "static/media/quest_ocean_discovery.69071d64.svg";